import React, { useState } from "react";
import { Formik } from "formik";
import { useIntl } from "react-intl";
import {
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  makeStyles,
  Typography,
  TablePagination,
  TableFooter,
  Button,
  Box
} from "@material-ui/core";
import { SubmitButton, TextField } from "./formik";
import { CreateQrScanLogDialog } from ".";

const useStyles = makeStyles(theme => ({
  headerRow: {
    backgroundColor: theme.palette.primary.main
  },
  headerText: {
    color: theme.palette.primary.contrastText
  },
  formContainer: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2)
  },
  textField: {
    marginRight: theme.spacing(2),
    flex: 1
  },
  chipTerziary: {
    backgroundColor: "gold"
  }
}));

const ChipStatus = ({ status }) => {
  const intl = useIntl();
  const classes = useStyles();

  switch (status) {
    case "not_entered":
      return (
        <Chip
          label={intl.formatMessage({
            id: "Chip.Label.NotEntered",
            defaultMessage: "Not Entered"
          })}
          className={classes.chipTerziary}
        />
      );
    case "already_entered":
      return (
        <Chip
          label={intl.formatMessage({
            id: "Chip.Label.AlreadyEntered",
            defaultMessage: "Already Entered"
          })}
          color="primary"
        />
      );
    case "already_exited":
      return (
        <Chip
          label={intl.formatMessage({
            id: "Chip.Label.AlreadyExited",
            defaultMessage: "Already Exited"
          })}
          color="secondary"
        />
      );
    default:
      return status;
  }
};

const AccessList = ({
  roomId,
  users,
  filter,
  setFilter,
  setPage,
  totalUsers,
  page,
  perPage,
  setAllAsExited
}) => {
  const intl = useIntl();
  const classes = useStyles();

  const [user, setUser] = useState(null);

  const onSubmit = ({ filter }) => {
    setFilter(filter);
    setPage(0);
  };

  const onPageChange = (event, newPage) => {
    setPage(newPage);
  };

  const onSetAllAsExited = () => {
    setAllAsExited();
  };

  return (
    <>
      <Box>
        <Button variant="contained" color="primary" onClick={onSetAllAsExited}>
          {intl.formatMessage({
            id: "PhysicalRoom.AccessList.SetAllAsExited",
            defaultMessage: "Set All As Exited"
          })}
        </Button>
      </Box>
      <Formik onSubmit={onSubmit} initialValues={{ filter }}>
        <div className={classes.formContainer}>
          <TextField
            name="filter"
            variant="outlined"
            label={intl.formatMessage({
              id: "PhysicalRoom.AccessList.Filter",
              defaultMessage: "Email, Name or Surname"
            })}
            className={classes.textField}
          />
          <SubmitButton variant="contained" color="primary" defaultEnabled>
            {intl.formatMessage({
              id: "PhysicalRoom.AccessList.Search",
              defaultMessage: "Search"
            })}
          </SubmitButton>
        </div>
      </Formik>

      <TableContainer component={Paper}>
        <Table aria-label="user table">
          <TableHead>
            <TableRow className={classes.headerRow}>
              <TableCell>
                <Typography variant="h6" className={classes.headerText}>
                  <strong>
                    {intl.formatMessage({
                      id: "PhysicalRoom.AccessList.Name",
                      defaultMessage: "Name"
                    })}
                  </strong>
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h6" className={classes.headerText}>
                  <strong>
                    {intl.formatMessage({
                      id: "PhysicalRoom.AccessList.Surname",
                      defaultMessage: "Surname"
                    })}
                  </strong>
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="h6" className={classes.headerText}>
                  <strong>
                    {intl.formatMessage({
                      id: "PhysicalRoom.AccessList.Status",
                      defaultMessage: "Status"
                    })}
                  </strong>
                </Typography>
              </TableCell>
              <TableCell />
            </TableRow>
          </TableHead>

          <TableBody>
            {users.map(user => (
              <TableRow key={user.id}>
                <TableCell>{user.profile.first_name}</TableCell>
                <TableCell>{user.profile.last_name}</TableCell>
                <TableCell>
                  <ChipStatus status={user.status_in_room} />
                </TableCell>
                <TableCell>
                  <Button variant="contained" color="primary" onClick={() => setUser(user)}>
                    {intl.formatMessage({
                      id: "PhysicalRoom.AccessList.SetManually",
                      defaultMessage: "Set Manually"
                    })}
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[perPage]}
                count={totalUsers}
                page={page}
                onPageChange={onPageChange}
                rowsPerPage={perPage}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
      {user && (
        <CreateQrScanLogDialog
          selectedRoom={roomId}
          selectedUser={user}
          setUserId={setUser}
          handleCloseDialog={() => setUser(null)}
        />
      )}
    </>
  );
};
export default AccessList;
